import React from 'react'
import CustomInput from '../../../components/Input/Input'

import { labelClassNames } from './index'

let timeOut = null

function KeyNestFields (props) {
  const {
    setFilters,
    searchValue,
    setSearchValue,
    keyTypeValue,
    setKeyTypeValue
  } = props

  return (
    <>
      <div className="w-[200px]">
        <div className={labelClassNames}>
          Search key
        </div>

        <CustomInput
          placeholder="Search"
          value={searchValue}
          allowClear
          onChange={(e) => {
            setSearchValue(e.target.value)

            if (timeOut) {
              clearTimeout(timeOut)
            }
            timeOut = setTimeout(() => {
              setFilters(prev => ({
                ...prev,
                searchKeys: e.target.value
              }))
            }, 600)
          }}
        />
      </div>

      <div className="w-[200px]">
        <div className={labelClassNames}>
          Key Type
        </div>

        <CustomInput
          placeholder="Search by key type..."
          allowClear
          value={keyTypeValue}
          onChange={(e) => {
            setKeyTypeValue(e.target.value)

            if (timeOut) {
              clearTimeout(timeOut)
            }
            timeOut = setTimeout(() => {
              setFilters(prev => ({
                ...prev,
                keyType: e.target.value
              }))
            }, 600)
          }}
        />
      </div>
    </>
  )
}

export default KeyNestFields